module.exports = __webpack_public_path__ + "static/media/randomize-active.79979a3a.svg";